import { Box, styled } from '@mui/material';

export const ApptRequestListWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  margin: 0,
  height: '100%'
});
